export const baseToMarketRate = {
    "EUR": 0.90969,
    "GBP": 0.76120,
    "CAD": 1.2776,
    "MXN": 21.046,
    "SEK": 9.03,
    "PLN": 4.07,
    "USD": 1
};